import { connect } from 'react-redux';
import { stepValidationStatusChanged, toggleScreens, updateSectionPermissions } from '../actions';
import ScreenPageStep from '../components/ScreenPageStep';
import { getScreenPageStep } from '../selectors';

const mapStateToProps = state => getScreenPageStep(state);

const mapDispatchToProps = dispatch => ({
    toggleScreens: (...args) => {
        dispatch(toggleScreens(...args));
    },
    updateSectionPermissions: (...args) => {
        dispatch(updateSectionPermissions(...args));
    },
    onStepValidationStatusChanged: stepValidationStatus => {
        dispatch(stepValidationStatusChanged(stepValidationStatus));
    },
});

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(ScreenPageStep);
